// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePopper } from 'react-popper';
import { ReactComponent as IconInvoiceLogo } from '../../../../../assets/svg/invoices-icons/icon-invoice-logo.svg';
import { ReactComponent as IconInvoiceColor } from '../../../../../assets/svg/invoices-icons/icon-invoice-color.svg';
import { ReactComponent as IconPaymentOptions } from '../../../../../assets/svg/invoices-icons/icon-payment-options.svg';
import { ReactComponent as IconPaymentDetails } from '../../../../../assets/svg/invoices-icons/icon-payment-details.svg';
import { ListMenu } from '../ListMenu';

const MENU_ITEM_NAMES = {
  INVOICE_LOGO: 'invoice-logo',
  INVOICE_COLOR: 'invoice-color',
  PAYMENT_OPTIONS: 'payment-options',
  PAYMENT_DETAILS: 'payment-details',
};

const MENU_ITEMS_LINKS = {
  [MENU_ITEM_NAMES.INVOICE_LOGO]: '/invoices/logo',
  [MENU_ITEM_NAMES.INVOICE_COLOR]: '/invoices/color',
  [MENU_ITEM_NAMES.PAYMENT_OPTIONS]: '/invoices/payment-options',
  [MENU_ITEM_NAMES.PAYMENT_DETAILS]: '/invoices/payment-details',
};

const MENU_ITEMS = [
  {
    icon: IconInvoiceLogo,
    title: 'INVOICE_SETTINGS.MENU_OPTION_INVOICE_LOGO',
    name: MENU_ITEM_NAMES.INVOICE_LOGO,
    testId: 'setInvoiceLogoAction',
  },
  {
    icon: IconInvoiceColor,
    title: 'INVOICE_SETTINGS.MENU_OPTION_INVOICE_COLOR',
    name: MENU_ITEM_NAMES.INVOICE_COLOR,
    testId: 'setInvoiceColorAction',
  },
  {
    title: '',
    SVGComponent: '',
    name: '',
    testId: 'subMenuSplitter',
  },
  {
    icon: IconPaymentOptions,
    title: 'INVOICE_SETTINGS.MENU_OPTION_PAYMENT_OPTIONS',
    name: MENU_ITEM_NAMES.PAYMENT_OPTIONS,
    testId: 'setPaymentOptionAction',
  },
  {
    icon: IconPaymentDetails,
    title: 'INVOICE_SETTINGS.MENU_OPTION_PAYMENT_DETAILS',
    name: MENU_ITEM_NAMES.PAYMENT_DETAILS,
    testId: 'setPaymentDetailsAction',
  },
];

export const InvoiceSettingsSubMenu = ({ referenceElement, onClose } : { referenceElement: any, onClose: () => void }) => {
  const { t } = useTranslation();
  const [popperElement, setPopperElement] = useState<any>();
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'bottom',
  });
  const menuItems = useMemo(() => MENU_ITEMS.map(item => ({
    SVGComponent: item.icon,
    title: t(item.title),
    name: item.name,
    testId: item.testId,
  })), []);
  const handleMenuItemClick = (menuItemName: string) => {
    onClose();
    window.location.href = MENU_ITEMS_LINKS[menuItemName];
  };
  return (
    <div
      className='z-20 mt-[8px]'
      ref={setPopperElement}
      style={styles.popper}
      {...attributes.popper}
    >
      <ListMenu testId='invoice-hub__settings-sub-menu' menuItems={menuItems} onMenuItemClick={handleMenuItemClick} className='shadow-none border-[1px] border-bw03 w-[288px]' />
    </div>
  );
};
